import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {errorListClear, infoListClear} from "../../state/action/alertActions";
import Icon, {CLOSE} from "../Icon";

import '../../style/AlertFooter.css';

class AlertFooter extends Component {
    render() {
        if (Object.keys(this.props.errorMap).length > 0 || Object.keys(this.props.infoMap).length > 0) {
            return (
                <div className={'alert_footer-wrapper'}>
                    <div className={'alert_footer-inner-wrapper'}>
                        <div className={'alert_footer-list'}>
                            {Object.keys(this.props.infoMap).map((key) => {
                                return <div key={key}
                                            className={'alert_footer-info-list'}>{this.props.infoMap[key]}</div>;
                            })}
                            {Object.keys(this.props.errorMap).map((key) => {
                                return <div key={key}
                                            className={'alert_footer-error-list'}>{this.props.errorMap[key]}</div>;
                            })}
                        </div>
                        <div onClick={this.props.clearList}
                             className={'box-center'}>
                            <Icon iconName={CLOSE}/>
                        </div>
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }
}

AlertFooter.propTypes = {
    errorMap: PropTypes.object.isRequired
};

const mapStateToProps = state => {
    const {alert} = state;
    return {
        errorMap: alert.errorMap,
        infoMap: alert.infoMap
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        clearList: () => {
            dispatch(errorListClear());
            dispatch(infoListClear());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AlertFooter);


// WEBPACK FOOTER //
// ./src/component/alert/AlertFooter.jsx